import EOSReport from "reports/components/Reports/EOSReport";
import { ProcessGroupPnlBreakdowns } from "reports/components/Reports/GenericCharts/MetricAndPnLBreakdowns/ProcessGroupPnlBreakdowns";
import { getEosDateStringWithGeAndLt } from "reports/components/Reports/ReportHeader";
import { useGeAndLtFromUrl } from "reports/components/Reports/reportUtils";
import { startCase } from "lodash";
import { MetricEnum } from "reports/utils/metricTypes";
import { LINE_TO_CONSTRAINT_MAPPING } from "../eos/KrugerEOS";

export default function KrugerTagging() {
  const { ge, lt } = useGeAndLtFromUrl();
  const dateString = getEosDateStringWithGeAndLt(ge, lt);

  const sampleLink = "/tagging?ge=1649070000000&lt=1649674800000";

  const processGroupListWithConstraint = Object.keys(
    LINE_TO_CONSTRAINT_MAPPING
  ).map(key => {
    return {
      processGroupName: startCase(key),
      machemetryIds: [LINE_TO_CONSTRAINT_MAPPING[key]],
    };
  });

  return (
    <EOSReport
      // Hard coded a random machemetry ID to reuse the EOS Report component
      machemetryIds={["kruger_d_203"]}
      customSubTitle={"Weekly Tagging Performance"}
      sampleLink={sampleLink}
    >
      <ProcessGroupPnlBreakdowns
        processGroupList={[]}
        processGroupListWithConstraint={processGroupListWithConstraint}
        summaryMetricsInputList={[
          { name: MetricEnum.TAGGING },
          { name: MetricEnum.AVAIL },
        ]}
        customSubHeader={dateString}
        shouldExpand={false}
        shouldShowButterfly={false}
      />
    </EOSReport>
  );
}
